import { PromoteHIExample, PromoteHIForm, useHIState } from './hi';
import { PromoteJobDotIsExample, PromoteJobDotIsForm, useJobDotIsState } from './jobDotIs';
import { PromoteTvinnaExample, PromoteTvinnaForm, useTvinnaState } from './tvinna';

export const configs = {
  tvinna: {
    title: 'Tvinna (tvinna.is)',
    Form: PromoteTvinnaForm,
    Example: PromoteTvinnaExample,
    useBoardState: useTvinnaState,
    link: 'tvinna.is',
    en: {
      price: 'ISK 15,500 + VAT',
      priceText: 'Posting price is ISK 15,500 + VAT and is live as long as you wish.',
    },
    is: {
      price: '15.500kr. + VSK',
      priceText: 'Auglýsingin kostar 15.500kr. + VSK og er í birtingu eins lengi og þú óskar.',
    },
  },
  hi: {
    title: 'Tengslatorg Háskóla Íslands (tengslatorg.hi.is)',
    Form: PromoteHIForm,
    Example: PromoteHIExample,
    useBoardState: useHIState,
    link: 'tengslatorg.hi.is',
    en: {
      price: 'Free',
      priceText:
        'Posting is free but moderated. Postings are vetted by employees of HI before publishing.',
    },
    is: {
      price: 'Frítt',
      priceText: 'Auglýsingin er frí en er yfirfarin og samþykkt af starfsfólki HÍ fyrir birtingu.',
    },
  },
  job_dot_is: {
    title: 'Job.is',
    Form: PromoteJobDotIsForm,
    Example: PromoteJobDotIsExample,
    useBoardState: useJobDotIsState,
    link: 'Job.is',
    en: {
      price: 'ISK 9,000 + VAT',
      priceText: 'Posting price is ISK 11,900 + VAT and is live until the deadline.',
    },
    is: {
      price: '9.000kr. + VSK',
      priceText:
        'Auglýsingin kostar 11.900 kr. + VSK og er í birtingu þar til umsóknarfrestur rennur út.',
    },
  },
};
